var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPalliative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_2321)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_80_2321)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_80_2321)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_80_2321",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 51,
    height: 51
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9995 0.219727H-0.000488281V50.2197H49.9995V0.219727Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_80_2321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0301 6.80561C40.0301 7.55054 39.4262 8.15455 38.6812 8.15455C37.9363 8.15455 37.3324 7.55066 37.3324 6.80561C37.3324 6.06068 37.9363 5.45666 38.6812 5.45666C39.4262 5.45666 40.0301 6.06068 40.0301 6.80561ZM45.267 6.80549C45.267 10.0203 42.9518 12.7045 39.9011 13.2781V37.201C39.9011 44.3795 34.0609 50.2197 26.8823 50.2197C19.704 50.2197 13.8641 44.3795 13.8641 37.201V30.9974C9.99681 30.4075 7.02418 27.0591 7.02418 23.0295V9.13543C5.68707 8.63852 4.73193 7.3496 4.73193 5.84182V3.73184C4.73193 1.79523 6.30755 0.219727 8.24405 0.219727C10.1807 0.219727 11.7563 1.79523 11.7563 3.73184V5.84182C11.7563 7.34973 10.8011 8.63865 9.46404 9.13543V23.0296C9.46404 26.1285 11.9851 28.6496 15.0839 28.6496C18.1827 28.6496 20.7038 26.1285 20.7038 23.0296V9.13543C19.3668 8.63865 18.4117 7.34973 18.4117 5.84182V3.73184C18.4118 1.79523 19.9873 0.219727 21.9239 0.219727C23.8605 0.219727 25.4362 1.79523 25.4362 3.73184V5.84182C25.4362 7.34973 24.481 8.63865 23.1439 9.13543V23.0296C23.1439 27.0591 20.1713 30.4077 16.304 30.9975V37.2012C16.304 43.0343 21.0494 47.7798 26.8823 47.7798C32.7155 47.7798 37.4611 43.0343 37.4611 37.2012V13.2782C34.4104 12.7046 32.0952 10.0204 32.0952 6.80561C32.0952 3.17406 35.0497 0.219727 38.6811 0.219727C42.3125 0.219727 45.267 3.17406 45.267 6.80549ZM20.8518 5.84182C20.8518 6.43302 21.3327 6.91394 21.9239 6.91394C22.5151 6.91394 22.9962 6.43302 22.9962 5.84182V3.73184C22.9962 3.14063 22.5153 2.65971 21.9239 2.65971C21.3327 2.65971 20.8518 3.14063 20.8518 3.73184V5.84182ZM9.31629 3.73184C9.31629 3.14063 8.83537 2.65971 8.24405 2.65971C7.65284 2.65971 7.17192 3.14063 7.17192 3.73184V5.84182C7.17192 6.43302 7.65284 6.91394 8.24405 6.91394C8.83525 6.91394 9.31629 6.43302 9.31629 5.84182V3.73184ZM42.827 6.80549C42.827 4.51947 40.9671 2.65971 38.6811 2.65971C36.3951 2.65971 34.5352 4.51959 34.5352 6.80549C34.5352 9.08541 36.3852 10.9415 38.6628 10.9514C38.6689 10.9514 38.675 10.9512 38.6811 10.9512C38.6872 10.9512 38.6933 10.9512 38.6994 10.9514C40.977 10.9415 42.827 9.08553 42.827 6.80549Z",
    fill: "#003588"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_2321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.219727)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_80_2321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.219727)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_80_2321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.219727)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalliative);
export default __webpack_public_path__ + "static/media/palliative.8e3fbdf1ccd565c365f46c4ec964b7d5.svg";
export { ForwardRef as ReactComponent };